// extracted by mini-css-extract-plugin
export default {"wrapper":"adminTabList_wrapper__DAk4u"};